/**
 * WebSocketBridge — connects WebSocket when doctor is authenticated.
 * Lives inside both AuthProvider and WebSocketProvider in the component tree.
 * Bridges auth state to WebSocket lifecycle without circular dependencies.
 */

import { useEffect } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { useWebSocket } from '@/contexts/WebSocketContext';

export function WebSocketBridge() {
  const { isAuthenticated, role, accessToken } = useAuth();
  const { connect, disconnect, status } = useWebSocket();

  useEffect(() => {
    if (isAuthenticated && role === 'doctor' && accessToken && status === 'disconnected') {
      connect(accessToken);
    } else if (!isAuthenticated && status !== 'disconnected') {
      disconnect();
    }
  }, [isAuthenticated, role, accessToken, connect, disconnect, status]);

  return null;
}
